import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router";

import * as Api from "@/api";
import MasterListVirtualized from "@/design/components/MasterListVirtualized";
import { disableSearch, enableSearch } from "@/store/reducers/ui";
import useSearch from "@/utils/hooks/useSearch";
import { toggleLoadingState } from "@/utils/utility";
import { viPhoneOffice } from "@sippy-platform/valkyrie";

import { useMediaQuery, useTheme } from "@mui/material";

function DeviceList() {
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const theme = useTheme();
  const matchesMdUp = useMediaQuery(theme.breakpoints.up("md"));

  const deviceStore = useSelector((state) => state.backstage.devices);
  const searchValue = useSelector((state) => state.ui.searchValue);
  const progressBar = useSelector((state) => state.ui.progressBar);

  // Search every time deviceList or searchQuery changes
  const searchResults = useSearch(deviceStore.list, searchValue, ["brand", "type"]);

  useEffect(() => {
    toggleLoadingState(true);
    Promise.resolve(Api.getDevices()).finally(toggleLoadingState);
  }, []);

  // Open first item if the viewport is large enough
  useEffect(() => {
    if (!id && matchesMdUp && deviceStore.meta.lastFetched) {
      navigate(`${deviceStore.list[0].id}`);
    }
  }, [id, matchesMdUp, navigate, deviceStore.list, deviceStore.meta.lastFetched]);

  useEffect(() => {
    dispatch(enableSearch());
  }, [dispatch]);
  useEffect(() => () => dispatch(disableSearch()), [dispatch]);

  return (
    <>
      <MasterListVirtualized
        title="Devices"
        aria-label="Device list"
        id="device-list"
        list={searchResults}
        listItemProps={{
          primary: (x) => x.type,
          secondary: (x) => x.brand,
          to: (x) => `../${x.id}`,
          selected: (x) => x.id === Number(id),
          icon: viPhoneOffice,
        }}
        hideContentLoader={deviceStore.meta.count >= 1 && searchResults.length >= 1}
        contentLoaderProps={{
          count: deviceStore.meta.count,
          loading: progressBar,
          noItems: "You don't have any devices yet",
          noResults: "No devices in your current query",
          fetching: "Getting your devices",
          icon: viPhoneOffice,
        }}
      />
    </>
  );
}

export default DeviceList;
